/**
 * Created by Alican Köker on 2019-06-24.
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { EdisonGameConfig } from "../EdisonGameConfig";
import { ScalableLayer } from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import { EdisonHelper } from "../../utils/EdisonHelper";
import { Orientation } from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import { TweenLite } from "gsap";

export class EdisonAnticipationOverlay extends BaseView {

    private _layer:ScalableLayer;
    private _spine:PIXI.spine.Spine;
    private _container:PIXI.Container;
    private _currentIndex:number = 0;
    private _orientation:Orientation = Orientation.LANDSCAPE;
    private _focusObject:PIXI.Graphics;
    private _currentFocus:number = -1;
    private _currentFocusScatter:boolean = false;

    constructor() {
        super();

        this._layer = StageManager.getLayer(EdisonGameConfig.instance.LAYERS.ANTICIPATION.name);
        this._container = new PIXI.Container();
        this._layer.addChild(this._container);
    }

    protected initAnimations():void {
        this._focusObject = new PIXI.Graphics();
        this._layer.addChild(this._focusObject);

        this._spine = new PIXI.spine.Spine(GameResources.getSpineAsset("scatterAnticipation"));
        this._spine.visible = false;
        this._spine.scale.set(.88);
        this._container.addChild(this._spine);
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
        this.setSpineReel(this._currentIndex);
        if(this._currentFocus > -1)
            this.focusOnReel(this._currentFocus, this._currentFocusScatter);
    }

    public playWinAnticipation(reelId:number):void {
        this._spine.visible = true;
        this.setSpineReel(reelId);
        this._spine.state.setAnimation(0, "NeutralLoop", true);
        this.focusOnReel(reelId);
    }

    public playFreespinAnticipation(reelId:number):void {
        this._spine.visible = true;
        this.setSpineReel(reelId);
        this._spine.state.setAnimation(0, "ScatterLoop", true);
        this.focusOnReel(reelId, true);
    }

    public stopAnticipation():void {
        this._spine.state.setEmptyAnimation(0, 0);
        this._spine.visible = false;
        this._focusObject.clear();
        this._currentFocus = -1;
    }

    private setSpineReel(reelId:number):void {
        const topGap:number = this._orientation === Orientation.LANDSCAPE ? 183 : 77;
        this._currentIndex = reelId;
        let pos:number[] = EdisonHelper.getSymbolPosition(reelId, 0);
        this._spine.position.set(pos[0] + 75, pos[1] + topGap);
    }

    private focusOnReel(reelIndex:number, scatter:boolean = false):void {
        this._focusObject.clear();
        this._focusObject.alpha = 0;
        this._currentFocus = reelIndex;
        this._currentFocusScatter = scatter;

        const portraitHoleTopGap:number = this._orientation === Orientation.LANDSCAPE ? 0 : -105;
        const portraitFillTopGap:number = -500;
        const focusW:number = 1600;
        const focusH:number = 1600;

        let pos:number[] = EdisonHelper.getSymbolPosition(reelIndex, 0);
        this._focusObject.beginFill(0x281143, .3);
        this._focusObject.moveTo(-300, portraitFillTopGap + portraitHoleTopGap);
        this._focusObject.lineTo(focusW, portraitFillTopGap + portraitHoleTopGap);
        this._focusObject.lineTo(focusW, focusH + portraitHoleTopGap);
        this._focusObject.lineTo(-300, focusH + portraitHoleTopGap);
        this._focusObject.beginFill(0xffffaa);
        this._focusObject.beginHole();
        this._focusObject.moveTo(pos[0], pos[1] - 10 + portraitHoleTopGap);
        if(scatter) {
            this._focusObject.lineTo(pos[0], pos[1] - 25 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 10, pos[1] - 65 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 28, pos[1] - 75 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 40, pos[1] - 85 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 110, pos[1] - 85 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 122, pos[1] - 75 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 140, pos[1] - 65 + portraitHoleTopGap);
            this._focusObject.lineTo(pos[0] + 150, pos[1] - 25 + portraitHoleTopGap);
        }
        this._focusObject.lineTo(pos[0] + 150, pos[1] - 10 + portraitHoleTopGap);
        this._focusObject.lineTo(pos[0] + 150, pos[1] + 450 + portraitHoleTopGap);
        this._focusObject.lineTo(pos[0], pos[1] + 450 + portraitHoleTopGap);
        this._focusObject.endHole();
        this._focusObject.closePath();

        TweenLite.to(this._focusObject, .5, {alpha : 1});
    }
}

0